export class AuthConfig {
    register: string;
    login: string;
    refresh: string;
    checkPhoneAndSendPin: string;
    logout?: string
}
